import { memo } from 'react'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import BaseNode from './BaseNode'
import { WorkflowNodeData } from '@store/workflowStore'

interface DecisionNodeProps {
  id: string
  data: WorkflowNodeData
  selected?: boolean
}

/**
 * DecisionNode - Now only handles Logical Conditions (weather, time, geofence, etc.)
 *
 * Challenge nodes (Question/Answer, QR Scanner, Number Pad, Moderator Approval)
 * now have their own dedicated node types and are rendered by ChallengeNode.
 */
function DecisionNode(props: DecisionNodeProps) {
  return (
    <BaseNode
      {...props}
      icon={<AccountTreeIcon fontSize="small" />}
      showTargetHandle={true}
      showSourceHandle={true}
      sourceHandleCount={1}
      headerLabel="Logical Conditions"
      hideConditionChip={false}
    />
  )
}

export default memo(DecisionNode)
